export default {"src":"/_next/static/media/Group-25756.61e276ce.svg","height":255,"width":439};